define([
	'internal_util/Util',
	'model/bindings/AbstractKeyBindingType'
], function (
	Util,
	AbstractKeyBindingType
) {
	'use strict';

	/**
	 * WebCryptoKeyBindingType class
	 * 
	 * @returns {WebCryptoKeyBinding}
	 */
	return function (secret, salt, keyId) {
		
		AbstractKeyBindingType.call(this, "WebCrypto", salt);

		var _secret = secret,
			_keyId = keyId;
	

		// public methods
		
		this.secret = function() {
			return _secret;
		};

		this.keyId = function() {
			return _keyId;
		};

		this.toObject = function () {
			return {
				type : this.type(),
				origin : this.origin(),
				salt: this.salt(),
				keyId: _keyId
			};
		};
		
		//Used for CID-issue (session-storage)
		this.toObjectWithSecret = function () {
			return {
				type : this.type(),
				origin : this.origin(),
				salt: this.salt(),
				keyId: _keyId,
				secret: _secret
			};
		};

	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/bindings/WebCryptoKeyBindingType.js
// module id = 174
// module chunks = 2